<form
    [attr.aria-label]="formAriaLabel()"
    [class.compact]="compact()"
    [class.outlined]="appearance() === 'outlined'"
    [class.scope-above]="scopeRowPosition() === 'above'"
    (submit)="onSubmit($event)"
>
    <div class="prompt-row">
        <label class="sr-only" [for]="inputId">Question for Quippy</label>
        <mat-form-field
            class="prompt-control auto-width w-full"
            qpxInput="search-filter"
            subscriptSizing="dynamic"
        >
            <textarea
                #questionInput
                [id]="inputId"
                matInput
                qpxTextareaAutosize
                minRows="1"
                [maxRows]="compact() ? 1 : maxRows()"
                class="quippy-input"
                maxlength="500"
                rows="1"
                [attr.aria-describedby]="ariaDescribedBy() ?? null"
                [placeholder]="placeholder()"
                [value]="question()"
                (input)="onInput()"
                (keydown)="onKeyDown($event)"
            ></textarea>
        </mat-form-field>

        <button
            qpxButton
            matButton="filled"
            type="submit"
            class="icon-only"
            context="primary"
            [disabled]="sendDisabled() || !question().trim()"
            [attr.aria-label]="sendAriaLabel()"
        >
            <ng-icon qpx matButtonIcon size="md" name="lucideSend" />
        </button>
    </div>

    @if (
        !scopeRowDismissed() &&
            scopeRowPosition() !== 'hidden' &&
            renderedScopeTemplate();
        as scopeTemplate
    ) {
        <div
            class="scope-row"
            [animate.leave]="
                scopeRowPosition() === 'above' ? 'scope-leave' : ''
            "
            [inert]="scopeRowDismissed()"
        >
            <div class="building-selector">
                <ng-container [ngTemplateOutlet]="scopeTemplate" />
            </div>
        </div>
    }
</form>
